import React from "react";
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';

import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import {GraphData} from './util-graphdata';
import GraphChart from './GraphChart';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

//import "./styles.css";
// need to import the vis network css in order to show tooltip
//import "./network.css";

export default class ExploreCard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tagDropDownData: [],
      variableDropDownData: [],
      triggerDropDownData:[],
      selectTags:[],
      selectVariables:[],
      selectTriggers:[],
      graphData: {"nodes":[],"edges":[]}
    };


    this.onTagNodeAdded = this.onTagNodeAdded.bind(this);
    this.onVariableNodeAdded = this.onVariableNodeAdded.bind(this);
    this.onTriggerNodeAdded = this.onTriggerNodeAdded.bind(this);
    this.setGraphData = this.setGraphData.bind(this);
  }

  componentDidMount(){
    const tagDropDownData = window.__GTM_DOCS__.tagData.map(tag => tag[0]);
    const variableDropDownData = window.__GTM_DOCS__.variableData.map(variable => variable[0]);
    const triggerDropDownData = window.__GTM_DOCS__.triggerData.map(trigger => trigger[0]);
    this.setState({
      tagDropDownData : tagDropDownData,
      variableDropDownData : variableDropDownData,
      triggerDropDownData: triggerDropDownData,
      selectTags:[tagDropDownData[0]]
    }, () => {
      this.setGraphData();
    });
  }

  onTagNodeAdded = (event, values) => {
    if(typeof values !== 'undefined'){
      if(values.length !== 0){
          this.setState({
            selectTags : values
          }, () => {
            this.setGraphData();
          });

      }else if(values.length === 0){
        this.setState({
          selectTags : []
        }, () => {
          this.setGraphData();
        });
      }
    }
  }

  onVariableNodeAdded = (event, values) => {
    if(typeof values !== 'undefined'){
      if(values.length !== 0){
          this.setState({
            selectVariables : values
          }, () => {
            this.setGraphData();
          });

      }else if(values.length === 0){
        this.setState({
          selectVariables : []
        }, () => {
          this.setGraphData();
        });
      }
    }
  }

  onTriggerNodeAdded = (event, values) => {
    if(typeof values !== 'undefined'){
      if(values.length !== 0){
          this.setState({
            selectTriggers : values
          }, () => {
            this.setGraphData();
          });

      }else if(values.length === 0){
        this.setState({
          selectTriggers : []
        }, () => {
          this.setGraphData();
        });
      }
    }
  }

  setGraphData = () =>{
    //console.log('in graph data');
    //console.log(this.state.selectTags)
    let data = GraphData(this.state.selectTags,
              window.__GTM_DOCS__.tagData,
              this.state.selectTriggers,
              window.__GTM_DOCS__.triggerData,
              this.state.selectVariables,
              window.__GTM_DOCS__.variableData
            );
    this.setState({
      graphData : data
    });
  }

render(){

  if(typeof this.state.tagDropDownData[0] !== 'undefined'){
    //console.log('tagdropdown')
    //console.log(this.state)
    //console.log(this.state)
  return (
    <div>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Grid container justify="space-evenly" spacing={2}>
              <Grid item>
                  <Autocomplete
                      multiple
                      onChange={this.onTagNodeAdded}
                      id="size-small-outlined-multi"
                      size="small"
                      options={this.state.tagDropDownData}
                      getOptionLabel={((option) => option.name)}
                      defaultValue={[this.state.tagDropDownData[0]]}
                      renderOption={(option, { selected }) => (
                        <React.Fragment>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.name}
                        </React.Fragment>
                      )}
                      style={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Tags"
                          placeholder="Tags"
                        />
                      )}
                    />
                </Grid>
                <Grid item>
                  <Autocomplete
                      multiple
                      onChange={this.onTriggerNodeAdded}
                      id="size-small-outlined-multi"
                      size="small"
                      options={this.state.triggerDropDownData}
                      getOptionLabel={(option) => option.name}
                      renderOption={(option, { selected }) => (
                        <React.Fragment>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.name}
                        </React.Fragment>
                      )}
                      style={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Triggers"
                          placeholder="Triggers"
                        />
                      )}
                    />
                </Grid>
                <Grid item>
                  <Autocomplete
                      multiple
                      onChange={this.onVariableNodeAdded}
                      id="size-small-outlined-multi"
                      size="small"
                      options={this.state.variableDropDownData}
                      getOptionLabel={(option) => option.name}
                      renderOption={(option, { selected }) => (
                        <React.Fragment>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={selected}
                          />
                          {option.name}
                        </React.Fragment>
                      )}
                      style={{ width: 300 }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          variant="outlined"
                          label="Variables"
                          placeholder="Variables"
                        />
                      )}
                    />
                </Grid>
              </Grid>
          </Grid>
          <Grid item xs={12}>
            <GraphChart key={Math.random()+'-'+Date.now()} data={this.state.graphData} />
          </Grid>
        </Grid>
    </div>
  );
}else{
  return (<div></div>);
}
}


}
